import { Button, Paper, Snackbar, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import VerTorneo from './VerTorneo';


export default function MenuTorneos(props) {

  useEffect(() => {
    //document.title = props.titulo;
  }, [props.titulo])

  const { id } = useParams();

  const [idBuscar, setIdBuscar] = useState("")
  const navegar = useNavigate();
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
    navigator.clipboard.writeText(id)
  }

  const handleBuscar = () => {
    navegar(idBuscar)
  }

  return (
    <div>
      {
        id ?
          <div>
            <VerTorneo id={id}/>
          </div>
          :
          <div>
            <Typography variant="h5">Torneo</Typography>
            <TextField sx={{my: 2}} fullWidth onChange={(e)=>{setIdBuscar(e.target.value)}} id="outlined-basic" label="ID" variant="outlined" />
            <Button variant="outlined" onClick={handleBuscar}>Buscar</Button>
          </div>
      }
    </div>
  )
}

/*
<Typography variant="h5">Torneo</Typography>
            <Paper elevation={2} sx={{ p: 2, my: 2}}>{id}</Paper>
            <Button variant="outlined" onClick={handleClick}>Copiar</Button>
            <Snackbar
              open={open}
              onClose={() => setOpen(false)}
              autoHideDuration={2000}
              message="Copiado en el portapapeles"
            />
*/

/*
<Typography variant="h5">Torneos Online</Typography>
            <TextField sx={{my: 2}} fullWidth onChange={(e)=>{setIdBuscar(e.target.value)}} id="outlined-basic" label="ID" variant="outlined" />
            <Button variant="outlined" onClick={handleBuscar}>Buscar</Button>
*/